export default __webpack_public_path__ + "static/media/HowitWork_M.11a884a7.png";